export const CP_GET_PRODUCT_INTEREST_DATA_ENDPOINT='/ProductReviews/GetProductInterestName';